// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file consignment_note_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverOnShiftSchema } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JobListSchema } from "./job_pb";
import { file_job } from "./job_pb";
import type { RouteListSchema } from "./route_pb";
import { file_route } from "./route_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file consignment_note_service.proto.
 */
export const file_consignment_note_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_driver_on_shift, file_google_protobuf_timestamp, file_job, file_route]);

/**
 * @generated from message raccoonai.SetCrewToShiftRequest
 */
export type SetCrewToShiftRequest = Message<"raccoonai.SetCrewToShiftRequest"> & {
  /**
   * @generated from field: required uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: repeated uint64 crew_ids = 3 [json_name = "crew_ids"];
   */
  crewIds: bigint[];
};

/**
 * @generated from message raccoonai.SetCrewToShiftRequest
 */
export type SetCrewToShiftRequestJson = {
  /**
   * @generated from field: required uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: repeated uint64 crew_ids = 3 [json_name = "crew_ids"];
   */
  crew_ids?: string[];
};

/**
 * Describes the message raccoonai.SetCrewToShiftRequest.
 * Use `create(SetCrewToShiftRequestSchema)` to create a new message.
 */
export const SetCrewToShiftRequestSchema: GenMessage<SetCrewToShiftRequest, {jsonType: SetCrewToShiftRequestJson}> = /*@__PURE__*/
  messageDesc(file_consignment_note_service, 0);

/**
 * SetShiftConsignmentNoteRequest declares the shift's own facts: where and when
 * the truck left and came back, and the engine hours and mileage it ran.
 *
 * @generated from message raccoonai.SetShiftConsignmentNoteRequest
 */
export type SetShiftConsignmentNoteRequest = Message<"raccoonai.SetShiftConsignmentNoteRequest"> & {
  /**
   * @generated from field: required uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 departure_location_id = 3 [json_name = "departure_location_id"];
   */
  departureLocationId: bigint;

  /**
   * @generated from field: optional uint64 arrival_location_id = 4 [json_name = "arrival_location_id"];
   */
  arrivalLocationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp departure_time = 5 [json_name = "departure_time"];
   */
  departureTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp arrival_time = 6 [json_name = "arrival_time"];
   */
  arrivalTime?: Timestamp;

  /**
   * @generated from field: optional double engine_hours = 7 [json_name = "engine_hours"];
   */
  engineHours: number;

  /**
   * @generated from field: optional double mileage = 8;
   */
  mileage: number;
};

/**
 * SetShiftConsignmentNoteRequest declares the shift's own facts: where and when
 * the truck left and came back, and the engine hours and mileage it ran.
 *
 * @generated from message raccoonai.SetShiftConsignmentNoteRequest
 */
export type SetShiftConsignmentNoteRequestJson = {
  /**
   * @generated from field: required uint64 driver_on_shift_id = 1 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 departure_location_id = 3 [json_name = "departure_location_id"];
   */
  departure_location_id?: string;

  /**
   * @generated from field: optional uint64 arrival_location_id = 4 [json_name = "arrival_location_id"];
   */
  arrival_location_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp departure_time = 5 [json_name = "departure_time"];
   */
  departure_time?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp arrival_time = 6 [json_name = "arrival_time"];
   */
  arrival_time?: TimestampJson;

  /**
   * @generated from field: optional double engine_hours = 7 [json_name = "engine_hours"];
   */
  engine_hours?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double mileage = 8;
   */
  mileage?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.SetShiftConsignmentNoteRequest.
 * Use `create(SetShiftConsignmentNoteRequestSchema)` to create a new message.
 */
export const SetShiftConsignmentNoteRequestSchema: GenMessage<SetShiftConsignmentNoteRequest, {jsonType: SetShiftConsignmentNoteRequestJson}> = /*@__PURE__*/
  messageDesc(file_consignment_note_service, 1);

/**
 * RouteConsignmentNote declares what one trip carried and how far it travelled.
 *
 * @generated from message raccoonai.RouteConsignmentNote
 */
export type RouteConsignmentNote = Message<"raccoonai.RouteConsignmentNote"> & {
  /**
   * @generated from field: required uint64 route_id = 1 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional double mileage = 2;
   */
  mileage: number;

  /**
   * @generated from field: optional double weight_kg = 3 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: optional double volume = 4;
   */
  volume: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 5 [json_name = "fact_start_at"];
   */
  factStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 6 [json_name = "fact_end_at"];
   */
  factEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 destination_location_id = 7 [json_name = "destination_location_id"];
   */
  destinationLocationId: bigint;
};

/**
 * RouteConsignmentNote declares what one trip carried and how far it travelled.
 *
 * @generated from message raccoonai.RouteConsignmentNote
 */
export type RouteConsignmentNoteJson = {
  /**
   * @generated from field: required uint64 route_id = 1 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional double mileage = 2;
   */
  mileage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double weight_kg = 3 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double volume = 4;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 5 [json_name = "fact_start_at"];
   */
  fact_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 6 [json_name = "fact_end_at"];
   */
  fact_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 destination_location_id = 7 [json_name = "destination_location_id"];
   */
  destination_location_id?: string;
};

/**
 * Describes the message raccoonai.RouteConsignmentNote.
 * Use `create(RouteConsignmentNoteSchema)` to create a new message.
 */
export const RouteConsignmentNoteSchema: GenMessage<RouteConsignmentNote, {jsonType: RouteConsignmentNoteJson}> = /*@__PURE__*/
  messageDesc(file_consignment_note_service, 2);

/**
 * SetRouteConsignmentNotesRequest writes a whole table of trips at once — every
 * route of a shift in one call, or a single route with one entry. Either all of
 * the notes land or none of them do.
 *
 * @generated from message raccoonai.SetRouteConsignmentNotesRequest
 */
export type SetRouteConsignmentNotesRequest = Message<"raccoonai.SetRouteConsignmentNotesRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: repeated raccoonai.RouteConsignmentNote notes = 2;
   */
  notes: RouteConsignmentNote[];
};

/**
 * SetRouteConsignmentNotesRequest writes a whole table of trips at once — every
 * route of a shift in one call, or a single route with one entry. Either all of
 * the notes land or none of them do.
 *
 * @generated from message raccoonai.SetRouteConsignmentNotesRequest
 */
export type SetRouteConsignmentNotesRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: repeated raccoonai.RouteConsignmentNote notes = 2;
   */
  notes?: RouteConsignmentNoteJson[];
};

/**
 * Describes the message raccoonai.SetRouteConsignmentNotesRequest.
 * Use `create(SetRouteConsignmentNotesRequestSchema)` to create a new message.
 */
export const SetRouteConsignmentNotesRequestSchema: GenMessage<SetRouteConsignmentNotesRequest, {jsonType: SetRouteConsignmentNotesRequestJson}> = /*@__PURE__*/
  messageDesc(file_consignment_note_service, 3);

/**
 * JobConsignmentNote declares what was serviced at one location.
 *
 * @generated from message raccoonai.JobConsignmentNote
 */
export type JobConsignmentNote = Message<"raccoonai.JobConsignmentNote"> & {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional double num_of_container = 2 [json_name = "num_of_container"];
   */
  numOfContainer: number;

  /**
   * @generated from field: optional double weight_kg = 3 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * Replaces the stored coefficients when non-empty; num_of_container and
   * fact_total_volume are then derived from them.
   *
   * @generated from field: repeated double container_coefficients = 4 [json_name = "container_coefficients"];
   */
  containerCoefficients: number[];

  /**
   * Overrides the derived volume.
   *
   * @generated from field: optional double fact_total_volume = 5 [json_name = "fact_total_volume"];
   */
  factTotalVolume: number;
};

/**
 * JobConsignmentNote declares what was serviced at one location.
 *
 * @generated from message raccoonai.JobConsignmentNote
 */
export type JobConsignmentNoteJson = {
  /**
   * @generated from field: required uint64 job_id = 1 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional double num_of_container = 2 [json_name = "num_of_container"];
   */
  num_of_container?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double weight_kg = 3 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Replaces the stored coefficients when non-empty; num_of_container and
   * fact_total_volume are then derived from them.
   *
   * @generated from field: repeated double container_coefficients = 4 [json_name = "container_coefficients"];
   */
  container_coefficients?: (number | "NaN" | "Infinity" | "-Infinity")[];

  /**
   * Overrides the derived volume.
   *
   * @generated from field: optional double fact_total_volume = 5 [json_name = "fact_total_volume"];
   */
  fact_total_volume?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.JobConsignmentNote.
 * Use `create(JobConsignmentNoteSchema)` to create a new message.
 */
export const JobConsignmentNoteSchema: GenMessage<JobConsignmentNote, {jsonType: JobConsignmentNoteJson}> = /*@__PURE__*/
  messageDesc(file_consignment_note_service, 4);

/**
 * SetJobConsignmentNotesRequest writes a whole table of service acts at once —
 * every job of a route in one call, or a single job with one entry. Either all of
 * the notes land or none of them do.
 *
 * @generated from message raccoonai.SetJobConsignmentNotesRequest
 */
export type SetJobConsignmentNotesRequest = Message<"raccoonai.SetJobConsignmentNotesRequest"> & {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: repeated raccoonai.JobConsignmentNote notes = 2;
   */
  notes: JobConsignmentNote[];
};

/**
 * SetJobConsignmentNotesRequest writes a whole table of service acts at once —
 * every job of a route in one call, or a single job with one entry. Either all of
 * the notes land or none of them do.
 *
 * @generated from message raccoonai.SetJobConsignmentNotesRequest
 */
export type SetJobConsignmentNotesRequestJson = {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: repeated raccoonai.JobConsignmentNote notes = 2;
   */
  notes?: JobConsignmentNoteJson[];
};

/**
 * Describes the message raccoonai.SetJobConsignmentNotesRequest.
 * Use `create(SetJobConsignmentNotesRequestSchema)` to create a new message.
 */
export const SetJobConsignmentNotesRequestSchema: GenMessage<SetJobConsignmentNotesRequest, {jsonType: SetJobConsignmentNotesRequestJson}> = /*@__PURE__*/
  messageDesc(file_consignment_note_service, 5);

/**
 * @generated from service raccoonai.ConsignmentNoteService
 */
export const ConsignmentNoteService: GenService<{
  /**
   * @generated from rpc raccoonai.ConsignmentNoteService.AddCrewMemberToShift
   */
  addCrewMemberToShift: {
    methodKind: "unary";
    input: typeof SetCrewToShiftRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.ConsignmentNoteService.SetShiftConsignmentNote
   */
  setShiftConsignmentNote: {
    methodKind: "unary";
    input: typeof SetShiftConsignmentNoteRequestSchema;
    output: typeof DriverOnShiftSchema;
  },
  /**
   * @generated from rpc raccoonai.ConsignmentNoteService.SetRouteConsignmentNotes
   */
  setRouteConsignmentNotes: {
    methodKind: "unary";
    input: typeof SetRouteConsignmentNotesRequestSchema;
    output: typeof RouteListSchema;
  },
  /**
   * @generated from rpc raccoonai.ConsignmentNoteService.SetJobConsignmentNotes
   */
  setJobConsignmentNotes: {
    methodKind: "unary";
    input: typeof SetJobConsignmentNotesRequestSchema;
    output: typeof JobListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_consignment_note_service, 0);

